import React, { ReactElement } from 'react';
import { Descriptions } from 'antd';

import { GenericValue } from '../../../../lib/PlannerMetadata';
import {
  formatColorBoolean,
  formatColorNumber,
  formatColorString,
  random_key,
} from './RolloutDiffUtils';
// import '../RolloutDiffViewer.css';
import './RolloutDiffUtils.css';

interface RolloutDiffValueProps {
  genericValue: GenericValue;
  varType: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  diff: {};
}

interface RolloutDiffValueState {}

export class RolloutDiffValue extends React.Component<
  RolloutDiffValueProps,
  RolloutDiffValueState
> {
  render() {
    const { genericValue } = this.props;
    return (
      <div>
        <p>Rollout Value</p>
        <Descriptions
          className="rollout-diff-descriptions"
          bordered
          size={'small'}
          column={1}
        >
          {this.generateItem(genericValue)}
        </Descriptions>
      </div>
    );
  }

  private generateItem = (genericValue: GenericValue) => {
    let rows: ReactElement<typeof Descriptions>[] = [];
    for (let k in genericValue) {
      const v = genericValue[k];
      if (v === undefined) {
        continue;
      }
      rows.push(
        <Descriptions.Item label={k} key={random_key()}>
          <span className="rollout-diff-item" key={random_key()}>
            {this.formatWithColor(k, v)}
          </span>
        </Descriptions.Item>,
      );
    }
    return rows;
  };

  private formatWithColor(k: string, v: any): any {
    const { varType } = this.props;
    if (!this.props.diff || this.props.diff[k] === undefined) {
      return this.formatVal(v);
    }
    const diffVal = this.props.diff[k];
    if (diffVal == null) {
      return <p className="rollout-target__title-added">{this.formatVal(v)}</p>;
    }
    if (v === undefined || v === null) {
      return <p className="rollout-target__title-deleted">` `</p>;
    }

    //type of value currently is only either number or string
    switch (typeof v) {
      case 'number':
        if (varType == 'boolean') {
          return formatColorBoolean(v, diffVal);
        } else {
          return formatColorNumber(v, diffVal);
        }
      case 'string':
        return formatColorString(v, diffVal);
      default:
        return v;
    }
  }

  private formatVal(v: any): any {
    const { varType } = this.props;
    if (varType == 'boolean' && typeof v == 'number') {
      return v == 1 ? 'true' : 'false';
    }
    return v;
  }
}
